import { graphql } from "@/graphql/generated/gql";

export const municipalPropertyRegisterQueryDocument = graphql(/* GraphQL */ `
  query MunicipalPropertyRegister($id: ID!) {
    municipalPropertyRegister(id: $id) {
      ...MunicipalPropertyRegisterFields
    }
  }
`);
